import { createWorkerAction } from '../../lib';
export var resizeWindow = createWorkerAction('RESIZE_WINDOW');
